import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import EducationPage from "./pages/EducationPage";
import WorksPage from "./pages/WorksPage";
import WorksProfessionalPage from "./pages/WorksProfessionalPage";
import WorksProjectsPage from "./pages/WorksProjectsPage";
import WorksProjectDetailPage from "./pages/WorksProjectDetailPage";
import WorksProfessionalDetailPage from "./pages/WorksProfessionalDetailPage";
import AskBotPage from "./pages/AskBotPage";
import DropListPage from "./pages/DropListPage";
import DropDetailPage from "./pages/DropDetailPage";
import ResumePage from "./pages/ResumePage";

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [nightMode, setNightMode] = useState(true);

  return (
    <div className={`App ${nightMode ? "night-mode" : ""}`}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/education" element={<EducationPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/works" element={<WorksPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/works/professional" element={<WorksProfessionalPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/works/professional/:slug" element={<WorksProfessionalDetailPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/works/projects" element={<WorksProjectsPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/works/projects/:slug" element={<WorksProjectDetailPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/askbot" element={<AskBotPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/drop" element={<DropListPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/drop/:slug" element={<DropDetailPage nightMode={nightMode} setNightMode={setNightMode} />} />
          <Route path="/resume" element={<ResumePage nightMode={nightMode} setNightMode={setNightMode} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
